import * as React from 'react';
import type { ConfigEntityDetail, EntityDetail } from '@web-config-app/core';
import { useIntl } from '@leagueplatform/locales';
import { Box, Image } from '@leagueplatform/genesis-core';
import { LinkableCell, TableCell } from '../table-pieces.component';

export type ImageCellProps = {
  item: ConfigEntityDetail | EntityDetail;
  value: unknown;
  getItemName: (data: ConfigEntityDetail | EntityDetail) => string | undefined;
  linkTo?: string;
};

export const ImageCell = ({
  item,
  value,
  getItemName,
  linkTo,
}: ImageCellProps) => {
  const { formatMessage } = useIntl();
  if (typeof value === 'string' && value.length > 0) {
    return (
      <LinkableCell linkTo={linkTo}>
        <Box
          css={{
            height: '$twoAndHalf',
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
            borderRadius: '$small',
          }}
        >
          <Image
            alt={getItemName(item) || formatMessage({ id: 'UNTITLED' })}
            src={value}
            css={{
              maxWidth: '$twoAndHalf',
              maxHeight: '100%',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>
      </LinkableCell>
    );
  }

  return <TableCell />;
};
